import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const createAsset = createAsyncThunk(
    "assetAction/createAsset",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.post("tms/assets", payload);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const updateAsset = createAsyncThunk(
    "assetAction/updateAsset",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.patch(`tms/assets/${id}`, payload);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AssetActionSlice = createSlice({
    name: "AssetActionSlice",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: null,
    },
    reducers: {
        resetAssetAction: (state) => {
            state.isLoading = false;
            state.success = false;
            state.error = null;
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createAsset.pending, (state) => {
                state.isLoading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(createAsset.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(createAsset.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            // Update
            .addCase(updateAsset.pending, (state) => {
                state.isLoading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(updateAsset.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(updateAsset.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetAssetAction } = AssetActionSlice.actions;
export default AssetActionSlice.reducer;
